export const MODE = {
  none: "none",
  closed: "closed",
  open: "open",
  authorized_cards: "authorized_cards",
  all: "all_cards",
} as const;

export type Mode = keyof typeof MODE;
